import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Modal from '../../shared/modals/modal.component';
import FormikProvider from '../../shared/forms/formikProvider.component';
import Form from '../../shared/forms/form.component';

import schema from './trialBalanceThreshold.schema';

import { TrialBalanceThresholdPropTypes } from '../../shared/propTypes/TrialBalanceThreshold';
import { PeriodPropTypes } from '../shared/propTypes';
import { requiredWhenPresent } from '../../shared/propTypes';

import { sharedSelectors } from './store/selectors';

const ModalTitles = {
  EDIT: 'Edit Trial Balance Out Of Balance Threshold',
};

class EditTrialBalanceThreshold extends PureComponent {
  static propTypes = {
    saveEntity: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    period: PeriodPropTypes,
    connectionName: requiredWhenPresent(['isVisible'], PropTypes.string),
    entityToEdit: requiredWhenPresent(['isVisible'], TrialBalanceThresholdPropTypes),
    openForEdit: PropTypes.bool,
    isSavingInProgress: PropTypes.bool,
    isVisible: PropTypes.bool,
  };

  save = (formData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit, connectionName } = this.props;

    saveEntity(
      {
        ...formData,
        periodName: period.name,
        connectionName,
      },
      openForEdit,
      {
        params: { periodName: period.name, connectionName },
        callback: resetForm,
      }
    );
    setSubmitting(false);
  };


  renderModal = ({ formik, schema }) => {
    const {
      hideModal,
      openForEdit,
      isSavingInProgress,
      isVisible,
    } = this.props;

    const submit = () => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    };

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-edit-trial-balance-out-of-balance-threshold-modal"
        title={ModalTitles.EDIT}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={submit} // eslint-disable-line react/jsx-no-bind
        isSubmitting={isSavingInProgress}
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
        />
      </Modal>
    );
  };


  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  isSavingInProgress: sharedSelectors.savingEntitySelector(state),
});


export default connect(
  mapStateToProps
)(EditTrialBalanceThreshold);
